import { handleApiCall } from "../apis";
import { endpoint } from "./endpoints";

/** Load admin profile from getProfile API */
export const fetchAdminProfile = async () => {
  const response = await handleApiCall("get", `${endpoint.getAdminProfile}`, {});

  if (response?.__sessionExpired) {
    return { ok: false, sessionExpired: true };
  }

  if (response?.__apiAlertHandled) {
    return { ok: false, alertHandled: true };
  }

  if (response?.data?.code === 200) {
    return { ok: true, data: response.data.data };
  }

  const data = response?.response?.data ?? response?.data ?? {};
  return {
    ok: false,
    message: data?.errorMessage ?? data?.message,
    unauthorized: data?.success === false,
    sessionExpired: Boolean(response?.__sessionExpired),
    alertHandled: Boolean(response?.__apiAlertHandled),
  };
};
